export const INVENTORY_MANAGEMENT_OPTIONS = Object.freeze({
  spreadsheet: 'spreadsheet',
  manualManagement: 'manualManagement',
  externalIMS: 'externalIMS',
  shopifyIMS: 'shopifyIMS',
  noManagement: 'noManagement',
});
